// Cloudflare Turnstile のウィジェット描画。
//
// サーバー側 (TurnstileHelper#turnstile_widget) がフォームに置いた .js-turnstile へ explicit render する。
// implicit (class="cf-turnstile") は api.js の読み込み時に DOM を走査するだけなので、
// Turbolinks の画面遷移後に現れたフォームを拾えない (WOWU のモーダルで実測)。
// api.js はページ内で 1 回だけ、.js-turnstile があるページでだけ読み込む。
//
// - ウィジェットは自分で hidden input (cf-turnstile-response) を親フォームへ差し込む。
//   呼び出し側は form の中に .js-turnstile を置くだけでよい
// - appearance: interaction-only … 追加確認が要るときだけ表示する (通常は不可視)
// - refresh-expired: auto … トークンは 300 秒で失効する。入力に時間のかかる登録フォームでも
//   送信時に有効なトークンが残るよう自動で取り直す
// - error-callback … 渡さないと api.js が TurnstileError を投げ、ユーザーには何も出ないまま
//   送信だけ失敗する袋小路になる (WOWU で実測)。握って案内文を出す
// - turbolinks:before-cache でウィジェットを外す。スナップショットに iframe が残ると
//   戻る操作での復元時に二重描画になる
//
// application と page の両パックから読み込まれるため、.js-turnstile が無いページでも実行される (何もしない)。

const API_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=ddTurnstileOnload&render=explicit';
const ERROR_CLASS = 'js-turnstile-error';
let apiPromise = null;

function loadApi() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      window.ddTurnstileOnload = () => resolve(window.turnstile);
      const script = document.createElement('script');
      script.src = API_SRC;
      script.async = true;
      document.head.appendChild(script);
    });
  }
  return apiPromise;
}

function errorNote(container) {
  const next = container.nextElementSibling;
  return next && next.classList.contains(ERROR_CLASS) ? next : null;
}

function showError(container) {
  let note = errorNote(container);
  if (!note) {
    note = document.createElement('p');
    // Bulma (help is-danger) と Tailwind (/about) のどちらのページでも赤字になるよう両方付ける
    note.className = `${ERROR_CLASS} help is-danger text-red-600 mt-2`;
    container.insertAdjacentElement('afterend', note);
  }
  note.textContent = container.dataset.errorMessage;
}

function hideError(container) {
  const note = errorNote(container);
  if (note) note.remove();
}

function renderAll() {
  // data-turnstile-state は「読み込み待ち」の間の二重描画を防ぐ印 (turbolinks:load が複数回走るため)
  const containers = Array.from(document.querySelectorAll('.js-turnstile:not([data-turnstile-state])'));
  if (containers.length === 0) return;
  containers.forEach((container) => { container.dataset.turnstileState = 'pending'; });

  loadApi().then((turnstile) => {
    containers.forEach((container) => {
      if (!container.isConnected) return;
      const widgetId = turnstile.render(container, {
        sitekey: container.dataset.sitekey,
        appearance: 'interaction-only',
        size: 'flexible',
        language: 'ja',
        'refresh-expired': 'auto',
        callback: () => hideError(container),
        // 戻り値 true は「呼び出し側で処理した」の意味。Cloudflare 側の自動リトライは続く
        'error-callback': (code) => {
          console.warn(`[turnstile] challenge failed: ${code}`);
          showError(container);
          return true;
        },
      });
      container.dataset.turnstileState = 'rendered';
      if (widgetId) container.dataset.widgetId = widgetId;
    });
  });
}

function removeAll() {
  document.querySelectorAll('.js-turnstile[data-turnstile-state]').forEach((container) => {
    if (window.turnstile && container.dataset.widgetId) window.turnstile.remove(container.dataset.widgetId);
    delete container.dataset.widgetId;
    delete container.dataset.turnstileState;
    hideError(container);
  });
}

// turbolinks:load は初回表示でも発火する
document.addEventListener('turbolinks:load', renderAll);
document.addEventListener('turbolinks:before-cache', removeAll);
